// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2r8pk","content":"RecentSearches_content__2nOfz"};